import type { ReactNode } from 'react';

type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'accent';

const TONE: Record<Tone, string> = {
  neutral: 'bg-kalkuel-surface-2 text-kalkuel-muted border border-kalkuel-border',
  info: 'bg-kalkuel-primary/12 text-kalkuel-primary',
  success: 'bg-emerald-100 text-emerald-800',
  warning: 'bg-amber-100 text-amber-900',
  danger: 'bg-red-100 text-red-800',
  accent: 'bg-kalkuel-accent-soft text-kalkuel-accent-strong',
};

export function Badge({
  children,
  tone = 'neutral',
  className = '',
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={[
        'inline-flex items-center rounded-pill px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider',
        TONE[tone],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
